import React from 'react';
import { usePolywizzContext } from '../context';
import PageTitle from '../../../components/PageTitle';

const PolywizzPageHeader = () => {
    const { t } = usePolywizzContext();

    const breadCrumbItems = [{ label: t('Insurnace/Polywizz'), path: '/insurance-polywizz' }];
    const title = t('Insurnace/Polywizz');

    return <PageTitle breadCrumbItems={breadCrumbItems} title={title} />;
};

export default PolywizzPageHeader;
